import React from 'react';
import { useTranslation } from "react-i18next";

const SearchBar = ({input,setKeyword}) => {
  const BarStyling = {background:"#F2F1F9", border:"none", padding:"0.7rem", margin:"10px 20px"};
  const { t } = useTranslation();
  return (
    <input 
     style={BarStyling}
     className="search-bar"
     key="random1"
     value={input}
     placeholder={t("Search Clients")}
     onChange={(e) => setKeyword(e.target.value)}
    />
  );
}

export default SearchBar